import { redirect } from "react-router-dom";

const NIVEL = { none: 0, view: 1, edit: 2 };

export function getPermissao(modulo) {
  try {
    const nivel =
      JSON.parse(localStorage.getItem("1"))?.usuarioCliente?.permissoes?.[
        modulo
      ];
    return nivel in NIVEL ? nivel : "none";
  } catch {
    return "none";
  }
}

export const temPermissao = (modulo, nivel = "view") =>
  NIVEL[getPermissao(modulo)] >= NIVEL[nivel];

export function permissaoLoader(modulo, nivel = "view", fallback = "/homeIn") {
  if (temPermissao(modulo, nivel)) return null;
  window.dispatchEvent(new CustomEvent("semPermissao", { detail: nivel }));
  return redirect(fallback);
}
